import { render, staticRenderFns } from "./SchoolSessionSelect.vue?vue&type=template&id=c4b4c82a"
import script from "./SchoolSessionSelect.vue?vue&type=script&lang=js"
export * from "./SchoolSessionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports